import type { OptionType } from '@innovamat/glimmer-components';

export const standards: OptionType[] = [
  { value: 'BUBBLE_TREE', label: 'Bubble Tree' },
  { value: 'COMMON_CORE', label: 'Common Core' },
  { value: 'NEW_JERSEY', label: 'New Jersey' },
  { value: 'WEST_VIRGINIA', label: 'West Virginia' },
  { value: 'PENNSYLVANIA', label: 'Pennsylvania' },
  { value: 'CALIFORNIA', label: 'California' },
  { value: 'ILLINOIS', label: 'Illinois' },
  { value: 'QA_STANDARD', label: 'QA_STANDARD' },
];
